import { Location as OrderLocation } from '@project44-models/order-entity';
import { TrackedShipmentStopLocation as ShipmentLocation } from '@project44-models/shipment-entity';

export const formatLocationAddress = (
  locationAddress:
    | ShipmentLocation['address']
    | OrderLocation['address']
    | undefined
    | null,
  config: { skipAddress: boolean } = { skipAddress: false },
): string => {
  const {
    addressLines = [],
    city = '',
    country = '',
    postalCode = '',
    state = '',
  } = locationAddress ?? {};

  const address = addressLines?.length ? addressLines.join(', ') : '';

  const chunks = config.skipAddress
    ? [city, state, country]
    : [address, city, state, country];

  return [
    chunks.filter(Boolean).join(', '),
    postalCode ? ` ${postalCode}` : '',
  ].join('');
};

export default formatLocationAddress;
